import { z } from 'zod/v3'
import { createFileRoute } from '@tanstack/react-router'
import { paginationSearchSchema } from '@/lib/pagination'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/documents'
)({
  validateSearch: paginationSearchSchema.extend({ tab: z.enum(['key', 'all']).optional(), keyDocument: z.string().optional(), testId: z.string().trim().min(1).optional() }),
  staticData: { pageHeader: { title: 'Documents', pad: false } },
})
